import { Stack, styled } from 'tamagui';
export const RootContainer = styled(Stack, {
  bc: '$background',
});
